// Additional food categories

export const foodsDatabaseExtended = [
  // ==================== FAST FOOD (20 items) ====================
  {
    name: 'Hamburger (Plain)',
    category: 'Fast Food',
    oz: 3.5,
    cal: 295,
    protein: 13,
    carbs: 27,
    fat: 14,
  },
  {
    name: 'Cheeseburger',
    category: 'Fast Food',
    oz: 4,
    cal: 330,
    protein: 15,
    carbs: 28,
    fat: 17,
  },
  {
    name: 'French Fries',
    category: 'Fast Food',
    oz: 2.8,
    cal: 250,
    protein: 3,
    carbs: 32,
    fat: 12,
  },
  {
    name: 'Fried Chicken (1 piece, thigh)',
    category: 'Fast Food',
    oz: 2.8,
    cal: 240,
    protein: 18,
    carbs: 10,
    fat: 15,
  },
  {
    name: 'Pizza (1 slice, cheese)',
    category: 'Fast Food',
    oz: 3,
    cal: 285,
    protein: 12,
    carbs: 36,
    fat: 10,
  },
  {
    name: 'Hot Dog with Bun',
    category: 'Fast Food',
    oz: 1.8,
    cal: 280,
    protein: 10,
    carbs: 22,
    fat: 17,
  },
  {
    name: 'Taco (Beef)',
    category: 'Fast Food',
    oz: 2.1,
    cal: 170,
    protein: 8,
    carbs: 13,
    fat: 9,
  },
  {
    name: 'Burrito (Beef)',
    category: 'Fast Food',
    oz: 5.3,
    cal: 378,
    protein: 14,
    carbs: 45,
    fat: 15,
  },
  {
    name: 'Chicken Sandwich',
    category: 'Fast Food',
    oz: 3.5,
    cal: 320,
    protein: 25,
    carbs: 32,
    fat: 10,
  },
  {
    name: 'Fish Sandwich',
    category: 'Fast Food',
    oz: 3.5,
    cal: 390,
    protein: 17,
    carbs: 40,
    fat: 18,
  },
  {
    name: 'Onion Rings',
    category: 'Fast Food',
    oz: 3,
    cal: 350,
    protein: 4,
    carbs: 40,
    fat: 18,
  },
  {
    name: 'Fried Shrimp',
    category: 'Fast Food',
    oz: 3,
    cal: 270,
    protein: 18,
    carbs: 15,
    fat: 14,
  },
  {
    name: 'Nachos with Cheese',
    category: 'Fast Food',
    oz: 2,
    cal: 220,
    protein: 5,
    carbs: 24,
    fat: 12,
  },
  {
    name: 'Chicken Nuggets (6 pieces)',
    category: 'Fast Food',
    oz: 2.8,
    cal: 280,
    protein: 17,
    carbs: 14,
    fat: 17,
  },
  {
    name: 'Mac and Cheese (Fast Food)',
    category: 'Fast Food',
    oz: 5.6,
    cal: 360,
    protein: 13,
    carbs: 46,
    fat: 14,
  },
  {
    name: 'Chicken Fajita',
    category: 'Fast Food',
    oz: 4,
    cal: 330,
    protein: 28,
    carbs: 28,
    fat: 12,
  },
  {
    name: 'Beef Enchilada',
    category: 'Fast Food',
    oz: 5.3,
    cal: 395,
    protein: 21,
    carbs: 32,
    fat: 20,
  },
  {
    name: 'Fried Okra',
    category: 'Fast Food',
    oz: 2.5,
    cal: 175,
    protein: 2,
    carbs: 17,
    fat: 10,
  },
  {
    name: 'Corn Dog',
    category: 'Fast Food',
    oz: 2.8,
    cal: 280,
    protein: 9,
    carbs: 24,
    fat: 16,
  },
  {
    name: 'Quesadilla (Chicken)',
    category: 'Fast Food',
    oz: 4.2,
    cal: 360,
    protein: 20,
    carbs: 28,
    fat: 18,
  },

  // ==================== BEVERAGES (15 items) ====================
  {
    name: 'Water',
    category: 'Beverages',
    oz: 8,
    cal: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Coffee (Black)',
    category: 'Beverages',
    oz: 8,
    cal: 2,
    protein: 0.3,
    carbs: 0,
    fat: 0,
  },
  {
    name: 'Tea (Black, Brewed)',
    category: 'Beverages',
    oz: 8,
    cal: 2,
    protein: 0,
    carbs: 0.7,
    fat: 0,
  },
  {
    name: 'Orange Juice',
    category: 'Beverages',
    oz: 8,
    cal: 112,
    protein: 2,
    carbs: 26,
    fat: 0.5,
  },
  {
    name: 'Apple Juice',
    category: 'Beverages',
    oz: 8,
    cal: 114,
    protein: 0.2,
    carbs: 28,
    fat: 0.3,
  },
  {
    name: 'Cranberry Juice',
    category: 'Beverages',
    oz: 8,
    cal: 144,
    protein: 0,
    carbs: 36,
    fat: 0.1,
  },
  {
    name: 'Grape Juice',
    category: 'Beverages',
    oz: 8,
    cal: 152,
    protein: 0.3,
    carbs: 37,
    fat: 0.2,
  },
  {
    name: 'Cola (Regular)',
    category: 'Beverages',
    oz: 8,
    cal: 105,
    protein: 0,
    carbs: 29,
    fat: 0,
  },
  {
    name: 'Sprite/7UP',
    category: 'Beverages',
    oz: 8,
    cal: 100,
    protein: 0,
    carbs: 27,
    fat: 0,
  },
  {
    name: 'Beer (Light)',
    category: 'Beverages',
    oz: 12,
    cal: 103,
    protein: 0.7,
    carbs: 5.9,
    fat: 0,
  },
  {
    name: 'Beer (Regular)',
    category: 'Beverages',
    oz: 12,
    cal: 150,
    protein: 1.6,
    carbs: 13,
    fat: 0,
  },
  {
    name: 'Wine (Red)',
    category: 'Beverages',
    oz: 5,
    cal: 125,
    protein: 0.3,
    carbs: 3.8,
    fat: 0,
  },
  {
    name: 'Wine (White)',
    category: 'Beverages',
    oz: 5,
    cal: 122,
    protein: 0.2,
    carbs: 1.4,
    fat: 0,
  },
  {
    name: 'Smoothie (Mixed Fruit)',
    category: 'Beverages',
    oz: 8,
    cal: 150,
    protein: 2,
    carbs: 35,
    fat: 0.5,
  },
  {
    name: 'Energy Drink',
    category: 'Beverages',
    oz: 8,
    cal: 110,
    protein: 0,
    carbs: 27,
    fat: 0,
  },

  // ==================== SNACKS (25 items) ====================
  {
    name: 'Potato Chips',
    category: 'Snacks',
    oz: 1,
    cal: 152,
    protein: 2,
    carbs: 15,
    fat: 10,
  },
  {
    name: 'Tortilla Chips',
    category: 'Snacks',
    oz: 1,
    cal: 142,
    protein: 2.1,
    carbs: 18,
    fat: 7,
  },
  {
    name: 'Pretzels',
    category: 'Snacks',
    oz: 1,
    cal: 108,
    protein: 2.7,
    carbs: 21,
    fat: 1,
  },
  {
    name: 'Popcorn (Air Popped)',
    category: 'Snacks',
    oz: 1,
    cal: 30,
    protein: 1,
    carbs: 6,
    fat: 0.3,
  },
  {
    name: 'Popcorn (Buttered)',
    category: 'Snacks',
    oz: 1,
    cal: 140,
    protein: 3,
    carbs: 16,
    fat: 7,
  },
  {
    name: 'Crackers (Graham)',
    category: 'Snacks',
    oz: 0.5,
    cal: 59,
    protein: 1,
    carbs: 11,
    fat: 1.3,
  },
  {
    name: 'Crackers (Saltine)',
    category: 'Snacks',
    oz: 0.5,
    cal: 48,
    protein: 1,
    carbs: 8,
    fat: 1.3,
  },
  {
    name: 'Granola Bar',
    category: 'Snacks',
    oz: 1.4,
    cal: 180,
    protein: 4,
    carbs: 24,
    fat: 9,
  },
  {
    name: 'Cereal Bar (Energy Bar)',
    category: 'Snacks',
    oz: 1.4,
    cal: 200,
    protein: 6,
    carbs: 26,
    fat: 7,
  },
  {
    name: 'Trail Mix',
    category: 'Snacks',
    oz: 1.4,
    cal: 200,
    protein: 6,
    carbs: 16,
    fat: 13,
  },
  {
    name: 'Beef Jerky',
    category: 'Snacks',
    oz: 1,
    cal: 116,
    protein: 17,
    carbs: 3,
    fat: 4.5,
  },
  {
    name: 'Dried Fruit Mix',
    category: 'Snacks',
    oz: 1,
    cal: 96,
    protein: 1,
    carbs: 24,
    fat: 0.2,
  },
  {
    name: 'Cheese Puffs',
    category: 'Snacks',
    oz: 1,
    cal: 158,
    protein: 2,
    carbs: 14,
    fat: 11,
  },
  {
    name: 'Cheese Crackers',
    category: 'Snacks',
    oz: 1,
    cal: 150,
    protein: 2,
    carbs: 17,
    fat: 8,
  },
  {
    name: 'Protein Bar',
    category: 'Snacks',
    oz: 1.8,
    cal: 200,
    protein: 20,
    carbs: 12,
    fat: 7,
  },
  {
    name: 'Pork Rinds',
    category: 'Snacks',
    oz: 0.5,
    cal: 80,
    protein: 9,
    carbs: 0,
    fat: 5,
  },
  {
    name: 'Sunflower Seeds (Roasted)',
    category: 'Snacks',
    oz: 1.4,
    cal: 231,
    protein: 7.7,
    carbs: 9.1,
    fat: 19.5,
  },
  {
    name: 'Pumpkin Seeds (Roasted)',
    category: 'Snacks',
    oz: 1,
    cal: 180,
    protein: 9,
    carbs: 3.5,
    fat: 16,
  },
  {
    name: 'Mixed Nuts (Dry Roasted)',
    category: 'Snacks',
    oz: 1,
    cal: 168,
    protein: 5,
    carbs: 8,
    fat: 14,
  },
  {
    name: 'Peanut Butter Cups',
    category: 'Snacks',
    oz: 0.5,
    cal: 80,
    protein: 2,
    carbs: 8,
    fat: 5,
  },
  {
    name: 'Rice Cakes',
    category: 'Snacks',
    oz: 0.3,
    cal: 35,
    protein: 0.7,
    carbs: 7,
    fat: 0.3,
  },
  {
    name: 'Corn Chips',
    category: 'Snacks',
    oz: 1,
    cal: 151,
    protein: 2.3,
    carbs: 17,
    fat: 8.5,
  },
  {
    name: 'Plantain Chips',
    category: 'Snacks',
    oz: 1,
    cal: 147,
    protein: 1.5,
    carbs: 17,
    fat: 8,
  },
  {
    name: 'Vegetable Chips',
    category: 'Snacks',
    oz: 1,
    cal: 130,
    protein: 2,
    carbs: 18,
    fat: 5,
  },
  {
    name: 'Fruit Leather',
    category: 'Snacks',
    oz: 0.5,
    cal: 40,
    protein: 0.5,
    carbs: 10,
    fat: 0.2,
  },

  // ==================== DESSERTS (20 items) ====================
  {
    name: 'Chocolate Chip Cookie',
    category: 'Desserts',
    oz: 0.5,
    cal: 69,
    protein: 0.9,
    carbs: 8,
    fat: 3.7,
  },
  {
    name: 'Brownie',
    category: 'Desserts',
    oz: 1.2,
    cal: 112,
    protein: 1.5,
    carbs: 18,
    fat: 4.5,
  },
  {
    name: 'Vanilla Ice Cream',
    category: 'Desserts',
    oz: 2,
    cal: 137,
    protein: 2.3,
    carbs: 16,
    fat: 7.3,
  },
  {
    name: 'Chocolate Ice Cream',
    category: 'Desserts',
    oz: 2,
    cal: 143,
    protein: 2.5,
    carbs: 17,
    fat: 7.6,
  },
  {
    name: 'Cake (Layer, Chocolate)',
    category: 'Desserts',
    oz: 1.8,
    cal: 235,
    protein: 2.5,
    carbs: 34,
    fat: 10,
  },
  {
    name: 'Cake (Angel Food)',
    category: 'Desserts',
    oz: 1.5,
    cal: 72,
    protein: 1.7,
    carbs: 16,
    fat: 0.1,
  },
  {
    name: 'Pie (Apple)',
    category: 'Desserts',
    oz: 4.9,
    cal: 296,
    protein: 2.3,
    carbs: 43,
    fat: 13,
  },
  {
    name: 'Pie (Pumpkin)',
    category: 'Desserts',
    oz: 4.9,
    cal: 316,
    protein: 4.9,
    carbs: 41,
    fat: 14,
  },
  {
    name: 'Donut (Glazed)',
    category: 'Desserts',
    oz: 1.6,
    cal: 192,
    protein: 2,
    carbs: 23,
    fat: 10,
  },
  {
    name: 'Donut (Chocolate)',
    category: 'Desserts',
    oz: 1.6,
    cal: 204,
    protein: 2.3,
    carbs: 24,
    fat: 11,
  },
  {
    name: 'Pudding (Chocolate)',
    category: 'Desserts',
    oz: 4,
    cal: 150,
    protein: 2,
    carbs: 28,
    fat: 4,
  },
  {
    name: 'Pudding (Vanilla)',
    category: 'Desserts',
    oz: 4,
    cal: 147,
    protein: 1.8,
    carbs: 28,
    fat: 4,
  },
  {
    name: 'Cheesecake',
    category: 'Desserts',
    oz: 2.8,
    cal: 280,
    protein: 4.5,
    carbs: 20,
    fat: 22,
  },
  {
    name: 'Tiramisu',
    category: 'Desserts',
    oz: 3.5,
    cal: 320,
    protein: 4,
    carbs: 30,
    fat: 18,
  },
  {
    name: 'Mousse (Chocolate)',
    category: 'Desserts',
    oz: 2.5,
    cal: 195,
    protein: 3,
    carbs: 19,
    fat: 12,
  },
  {
    name: 'Fruit Sorbet',
    category: 'Desserts',
    oz: 2,
    cal: 96,
    protein: 0.1,
    carbs: 24,
    fat: 0.1,
  },
  {
    name: 'Candy Bar (Generic)',
    category: 'Desserts',
    oz: 1.4,
    cal: 235,
    protein: 2,
    carbs: 33,
    fat: 11,
  },
  {
    name: 'Hard Candy',
    category: 'Desserts',
    oz: 0.35,
    cal: 60,
    protein: 0,
    carbs: 15,
    fat: 0,
  },
  {
    name: 'Gummy Bears',
    category: 'Desserts',
    oz: 0.5,
    cal: 60,
    protein: 0.8,
    carbs: 13,
    fat: 0.5,
  },
  {
    name: 'Jello',
    category: 'Desserts',
    oz: 3.5,
    cal: 80,
    protein: 1.7,
    carbs: 19,
    fat: 0,
  },

  // ==================== CONDIMENTS & SAUCES (15 items) ====================
  {
    name: 'Ketchup',
    category: 'Condiments',
    oz: 0.5,
    cal: 15,
    protein: 0,
    carbs: 4,
    fat: 0,
  },
  {
    name: 'Mustard (Yellow)',
    category: 'Condiments',
    oz: 0.5,
    cal: 3,
    protein: 0.2,
    carbs: 0.3,
    fat: 0.2,
  },
  {
    name: 'Mayonnaise',
    category: 'Condiments',
    oz: 0.5,
    cal: 180,
    protein: 0,
    carbs: 0,
    fat: 20,
  },
  {
    name: 'Olive Oil',
    category: 'Condiments',
    oz: 0.5,
    cal: 238,
    protein: 0,
    carbs: 0,
    fat: 27,
  },
  {
    name: 'Soy Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 10,
    protein: 1.5,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Hot Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 5,
    protein: 0.1,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Barbecue Sauce',
    category: 'Condiments',
    oz: 0.5,
    cal: 21,
    protein: 0,
    carbs: 5,
    fat: 0,
  },
  {
    name: 'Salsa',
    category: 'Condiments',
    oz: 0.5,
    cal: 5,
    protein: 0,
    carbs: 1,
    fat: 0,
  },
  {
    name: 'Peanut Butter',
    category: 'Condiments',
    oz: 0.5,
    cal: 94,
    protein: 4,
    carbs: 3.5,
    fat: 8,
  },
  {
    name: 'Jelly/Jam',
    category: 'Condiments',
    oz: 0.5,
    cal: 48,
    protein: 0,
    carbs: 13,
    fat: 0,
  },
  {
    name: 'Honey',
    category: 'Condiments',
    oz: 0.7,
    cal: 64,
    protein: 0.1,
    carbs: 17,
    fat: 0,
  },
  {
    name: 'Syrup (Maple)',
    category: 'Condiments',
    oz: 0.5,
    cal: 52,
    protein: 0,
    carbs: 13,
    fat: 0,
  },
  {
    name: 'Vinegar (Balsamic)',
    category: 'Condiments',
    oz: 0.5,
    cal: 14,
    protein: 0,
    carbs: 3,
    fat: 0,
  },
  {
    name: 'Butter',
    category: 'Condiments',
    oz: 0.5,
    cal: 102,
    protein: 0.1,
    carbs: 0,
    fat: 11.5,
  },
  {
    name: 'Salad Dressing (Ranch)',
    category: 'Condiments',
    oz: 0.5,
    cal: 73,
    protein: 0.1,
    carbs: 1,
    fat: 8,
  },

  // ==================== SOUPS (12 items) ====================
  {
    name: 'Chicken Noodle Soup',
    category: 'Soups',
    oz: 8,
    cal: 60,
    protein: 3,
    carbs: 9,
    fat: 1,
  },
  {
    name: 'Tomato Soup',
    category: 'Soups',
    oz: 8,
    cal: 74,
    protein: 1.5,
    carbs: 16,
    fat: 0.2,
  },
  {
    name: 'Minestrone Soup',
    category: 'Soups',
    oz: 8,
    cal: 82,
    protein: 4,
    carbs: 14,
    fat: 0.6,
  },
  {
    name: 'Clam Chowder',
    category: 'Soups',
    oz: 8,
    cal: 158,
    protein: 9,
    carbs: 12,
    fat: 7,
  },
  {
    name: 'Cream of Mushroom Soup',
    category: 'Soups',
    oz: 8,
    cal: 160,
    protein: 2,
    carbs: 10,
    fat: 12,
  },
  {
    name: 'Lentil Soup',
    category: 'Soups',
    oz: 8,
    cal: 85,
    protein: 6,
    carbs: 13,
    fat: 0.4,
  },
  {
    name: 'Vegetable Soup',
    category: 'Soups',
    oz: 8,
    cal: 50,
    protein: 2,
    carbs: 11,
    fat: 0.2,
  },
  {
    name: 'Beef Broth',
    category: 'Soups',
    oz: 8,
    cal: 17,
    protein: 3,
    carbs: 0,
    fat: 0.5,
  },
  {
    name: 'Chicken Broth',
    category: 'Soups',
    oz: 8,
    cal: 15,
    protein: 1.5,
    carbs: 1,
    fat: 0.5,
  },
  {
    name: 'Miso Soup',
    category: 'Soups',
    oz: 8,
    cal: 40,
    protein: 4,
    carbs: 2,
    fat: 1.5,
  },
  {
    name: 'Gazpacho (Cold Soup)',
    category: 'Soups',
    oz: 8,
    cal: 46,
    protein: 0.5,
    carbs: 10,
    fat: 0.3,
  },
  {
    name: 'French Onion Soup',
    category: 'Soups',
    oz: 8,
    cal: 140,
    protein: 3.5,
    carbs: 20,
    fat: 4.5,
  },

  // ==================== INTERNATIONAL (25 items) ====================
  {
    name: 'Sushi (Salmon Roll)',
    category: 'International',
    oz: 2.8,
    cal: 140,
    protein: 6,
    carbs: 17,
    fat: 5,
  },
  {
    name: 'Pad Thai',
    category: 'International',
    oz: 7,
    cal: 350,
    protein: 8,
    carbs: 45,
    fat: 14,
  },
  {
    name: 'General Tso Chicken',
    category: 'International',
    oz: 4.2,
    cal: 380,
    protein: 27,
    carbs: 25,
    fat: 18,
  },
  {
    name: 'Fried Rice (Chicken)',
    category: 'International',
    oz: 5.6,
    cal: 280,
    protein: 11,
    carbs: 35,
    fat: 10,
  },
  {
    name: 'Lo Mein',
    category: 'International',
    oz: 5.6,
    cal: 285,
    protein: 10,
    carbs: 38,
    fat: 10,
  },
  {
    name: 'Chow Mein',
    category: 'International',
    oz: 5.6,
    cal: 300,
    protein: 12,
    carbs: 25,
    fat: 16,
  },
  {
    name: 'Spring Roll',
    category: 'International',
    oz: 1.8,
    cal: 120,
    protein: 2,
    carbs: 12,
    fat: 6.5,
  },
  {
    name: 'Egg Roll',
    category: 'International',
    oz: 1.8,
    cal: 150,
    protein: 2.5,
    carbs: 15,
    fat: 8,
  },
  {
    name: 'Dumpling (Steamed)',
    category: 'International',
    oz: 0.7,
    cal: 50,
    protein: 1.5,
    carbs: 5,
    fat: 2,
  },
  {
    name: 'Falafel',
    category: 'International',
    oz: 1.8,
    cal: 170,
    protein: 6,
    carbs: 17,
    fat: 9,
  },
  {
    name: 'Hummus',
    category: 'International',
    oz: 1,
    cal: 99,
    protein: 2.6,
    carbs: 8,
    fat: 6,
  },
  {
    name: 'Tabouli',
    category: 'International',
    oz: 4.2,
    cal: 180,
    protein: 6,
    carbs: 26,
    fat: 7,
  },
  {
    name: 'Kebab (Beef)',
    category: 'International',
    oz: 3.5,
    cal: 300,
    protein: 25,
    carbs: 18,
    fat: 14,
  },
  {
    name: 'Gyro',
    category: 'International',
    oz: 3.5,
    cal: 350,
    protein: 20,
    carbs: 28,
    fat: 18,
  },
  {
    name: 'Moussaka',
    category: 'International',
    oz: 5.3,
    cal: 380,
    protein: 18,
    carbs: 25,
    fat: 23,
  },
  {
    name: 'Paella',
    category: 'International',
    oz: 6.3,
    cal: 380,
    protein: 18,
    carbs: 45,
    fat: 12,
  },
  {
    name: 'Risotto',
    category: 'International',
    oz: 5.6,
    cal: 350,
    protein: 10,
    carbs: 50,
    fat: 10,
  },
  {
    name: 'Pasta Carbonara',
    category: 'International',
    oz: 5.6,
    cal: 450,
    protein: 20,
    carbs: 38,
    fat: 23,
  },
  {
    name: 'Tikka Masala (Chicken)',
    category: 'International',
    oz: 6.3,
    cal: 300,
    protein: 25,
    carbs: 12,
    fat: 16,
  },
  {
    name: 'Tandoori Chicken',
    category: 'International',
    oz: 3.5,
    cal: 160,
    protein: 29,
    carbs: 2,
    fat: 3,
  },
  {
    name: 'Biryani (Chicken)',
    category: 'International',
    oz: 6.3,
    cal: 400,
    protein: 22,
    carbs: 48,
    fat: 14,
  },
  {
    name: 'Ceviche',
    category: 'International',
    oz: 3.5,
    cal: 110,
    protein: 18,
    carbs: 5,
    fat: 1.5,
  },
  {
    name: 'Empanada',
    category: 'International',
    oz: 2.8,
    cal: 280,
    protein: 8,
    carbs: 24,
    fat: 16,
  },
  {
    name: 'Pho (Beef)',
    category: 'International',
    oz: 10.6,
    cal: 280,
    protein: 16,
    carbs: 22,
    fat: 8,
  },
  {
    name: 'Tom Yum Soup',
    category: 'International',
    oz: 8,
    cal: 80,
    protein: 5,
    carbs: 8,
    fat: 2.5,
  },

  // ==================== BREAKFAST (20 items) ====================
  {
    name: 'Oatmeal with Milk',
    category: 'Breakfast',
    oz: 7,
    cal: 180,
    protein: 6,
    carbs: 32,
    fat: 3,
  },
  {
    name: 'Pancake (1 with syrup)',
    category: 'Breakfast',
    oz: 2.5,
    cal: 210,
    protein: 6,
    carbs: 30,
    fat: 8,
  },
  {
    name: 'Waffle (1)',
    category: 'Breakfast',
    oz: 2.5,
    cal: 218,
    protein: 5,
    carbs: 25,
    fat: 11,
  },
  {
    name: 'French Toast (1 slice)',
    category: 'Breakfast',
    oz: 2,
    cal: 150,
    protein: 5,
    carbs: 17,
    fat: 7,
  },
  {
    name: 'Cereal with Milk',
    category: 'Breakfast',
    oz: 8,
    cal: 180,
    protein: 6,
    carbs: 34,
    fat: 2,
  },
  {
    name: 'Bagel (Plain)',
    category: 'Breakfast',
    oz: 3.5,
    cal: 210,
    protein: 8,
    carbs: 41,
    fat: 1.5,
  },
  {
    name: 'Bagel with Cream Cheese',
    category: 'Breakfast',
    oz: 3.5,
    cal: 260,
    protein: 9,
    carbs: 42,
    fat: 6.5,
  },
  {
    name: 'Croissant (Plain)',
    category: 'Breakfast',
    oz: 2,
    cal: 230,
    protein: 5,
    carbs: 26,
    fat: 12,
  },
  {
    name: 'Muffin (Blueberry)',
    category: 'Breakfast',
    oz: 2,
    cal: 280,
    protein: 4,
    carbs: 40,
    fat: 10,
  },
  {
    name: 'Muffin (Chocolate Chip)',
    category: 'Breakfast',
    oz: 2,
    cal: 300,
    protein: 4,
    carbs: 41,
    fat: 12,
  },
  {
    name: 'Toast (White with Butter)',
    category: 'Breakfast',
    oz: 1.2,
    cal: 110,
    protein: 2.5,
    carbs: 14,
    fat: 5.5,
  },
  {
    name: 'Toast (Whole Wheat with Jam)',
    category: 'Breakfast',
    oz: 1.2,
    cal: 130,
    protein: 3,
    carbs: 20,
    fat: 2.5,
  },
  {
    name: 'Scrambled Eggs (2)',
    category: 'Breakfast',
    oz: 3.5,
    cal: 180,
    protein: 12,
    carbs: 1.2,
    fat: 14,
  },
  {
    name: 'Fried Eggs (2)',
    category: 'Breakfast',
    oz: 3.5,
    cal: 210,
    protein: 13,
    carbs: 0.6,
    fat: 17,
  },
  {
    name: 'Omelet (Ham and Cheese)',
    category: 'Breakfast',
    oz: 3.5,
    cal: 280,
    protein: 20,
    carbs: 2,
    fat: 21,
  },
  {
    name: 'Hash Browns',
    category: 'Breakfast',
    oz: 3,
    cal: 160,
    protein: 2,
    carbs: 18,
    fat: 9,
  },
  {
    name: 'Breakfast Sausage (2 links)',
    category: 'Breakfast',
    oz: 2,
    cal: 180,
    protein: 18,
    carbs: 1,
    fat: 11,
  },
  {
    name: 'Breakfast Bacon (3 slices)',
    category: 'Breakfast',
    oz: 1.5,
    cal: 160,
    protein: 12,
    carbs: 0,
    fat: 12.5,
  },
  {
    name: 'Breakfast Burrito',
    category: 'Breakfast',
    oz: 5.3,
    cal: 380,
    protein: 16,
    carbs: 38,
    fat: 18,
  },
  {
    name: 'Yogurt Parfait',
    category: 'Breakfast',
    oz: 6,
    cal: 250,
    protein: 12,
    carbs: 42,
    fat: 3.5,
  },

  // ==================== PREPARED MEALS (20 items) ====================
  {
    name: 'Beef Stew',
    category: 'Prepared Meals',
    oz: 8,
    cal: 240,
    protein: 20,
    carbs: 18,
    fat: 10,
  },
  {
    name: 'Chicken Stew',
    category: 'Prepared Meals',
    oz: 8,
    cal: 200,
    protein: 22,
    carbs: 12,
    fat: 6,
  },
  {
    name: 'Chicken Pot Pie',
    category: 'Prepared Meals',
    oz: 7,
    cal: 390,
    protein: 16,
    carbs: 36,
    fat: 20,
  },
  {
    name: 'Lasagna',
    category: 'Prepared Meals',
    oz: 6.3,
    cal: 420,
    protein: 24,
    carbs: 35,
    fat: 20,
  },
  {
    name: 'Meatloaf',
    category: 'Prepared Meals',
    oz: 3.5,
    cal: 320,
    protein: 20,
    carbs: 15,
    fat: 20,
  },
  {
    name: 'Chicken Teriyaki',
    category: 'Prepared Meals',
    oz: 5,
    cal: 280,
    protein: 30,
    carbs: 20,
    fat: 7,
  },
  {
    name: 'Beef and Broccoli',
    category: 'Prepared Meals',
    oz: 5,
    cal: 320,
    protein: 28,
    carbs: 12,
    fat: 16,
  },
  {
    name: 'Shrimp Scampi',
    category: 'Prepared Meals',
    oz: 4,
    cal: 240,
    protein: 26,
    carbs: 5,
    fat: 13,
  },
  {
    name: 'Fish and Chips',
    category: 'Prepared Meals',
    oz: 6,
    cal: 450,
    protein: 24,
    carbs: 40,
    fat: 22,
  },
  {
    name: 'Roasted Chicken (1/4)',
    category: 'Prepared Meals',
    oz: 4,
    cal: 280,
    protein: 40,
    carbs: 0,
    fat: 12,
  },
  {
    name: 'Grilled Salmon with Veggies',
    category: 'Prepared Meals',
    oz: 6,
    cal: 380,
    protein: 35,
    carbs: 10,
    fat: 20,
  },
  {
    name: 'Turkey Meatballs',
    category: 'Prepared Meals',
    oz: 3,
    cal: 180,
    protein: 22,
    carbs: 6,
    fat: 8,
  },
  {
    name: 'Vegetable Stir Fry',
    category: 'Prepared Meals',
    oz: 5,
    cal: 180,
    protein: 8,
    carbs: 18,
    fat: 8,
  },
  {
    name: 'Pasta Primavera',
    category: 'Prepared Meals',
    oz: 7,
    cal: 280,
    protein: 10,
    carbs: 45,
    fat: 6,
  },
  {
    name: 'Baked Cod with Lemon',
    category: 'Prepared Meals',
    oz: 4,
    cal: 160,
    protein: 28,
    carbs: 2,
    fat: 3,
  },
  {
    name: 'Stuffed Bell Pepper',
    category: 'Prepared Meals',
    oz: 5.3,
    cal: 220,
    protein: 14,
    carbs: 16,
    fat: 10,
  },
  {
    name: 'Chicken Fajita Plate',
    category: 'Prepared Meals',
    oz: 8,
    cal: 380,
    protein: 35,
    carbs: 30,
    fat: 12,
  },
  {
    name: 'Beef Tacos (2)',
    category: 'Prepared Meals',
    oz: 4.5,
    cal: 340,
    protein: 16,
    carbs: 26,
    fat: 18,
  },
  {
    name: 'Vegetarian Chili',
    category: 'Prepared Meals',
    oz: 8,
    cal: 200,
    protein: 12,
    carbs: 24,
    fat: 5,
  },
  {
    name: 'BBQ Pulled Pork Sandwich',
    category: 'Prepared Meals',
    oz: 4,
    cal: 360,
    protein: 26,
    carbs: 32,
    fat: 14,
  },
];
